import JSZip from 'jszip';

const MAX_PDFS_IN_ZIP = 50;

interface ISource {
  url: string;
  filename: string;
}

const PDF_SOURCES: ISource[] = [
  {
    url: '/guidance/batchDownload/Combined Statement.pdf',
    filename: 'Combined Statement.pdf',
  },
  {
    url: '/guidance/batchDownload/NoticeCU-MarchCD.pdf',
    filename: 'NoticeCU-MarchCD.pdf',
  },
  {
    url: '/guidance/batchDownload/TaxForm1042-S.pdf',
    filename: 'TaxForm1042-S.pdf',
  },
  {
    url: '/guidance/batchDownload/Visa-May2007.pdf',
    filename: 'Visa-May2007.pdf',
  },
  {
    url: '/guidance/batchDownload/statementMessage.pdf',
    filename: 'statementMessage.pdf',
  },
];

async function fetchPdfAsBlob(url: string): Promise<Blob> {
  const response = await fetch(url);

  if (!response.ok) throw new Error(`Failed to fetch ${url}`);

  return response.blob();
}

function getPdfUrlsForCount(count: number): ISource[] {
  const capped = Math.min(count, MAX_PDFS_IN_ZIP);
  const result: ISource[] = [];

  for (let i = 0; i < capped; i++) {
    const source = PDF_SOURCES[i % PDF_SOURCES.length];
    const baseName = source.filename.replace(/\.pdf$/i, '');

    const sameSourceLength = result.filter(item => item.url === source.url).length;
    const isDuplicate = sameSourceLength > 0;

    const filename = isDuplicate ? `${baseName} (${sameSourceLength + 1}).pdf` : source.filename;

    result.push({ ...source, filename });
  }

  return result;
}

interface IProps {
  blob: Blob;
  filename: string;
}

const createBatchDownloadBlob = async (selectedCount: number): Promise<IProps> => {
  const cappedCount = Math.min(selectedCount, MAX_PDFS_IN_ZIP);
  const pdfEntries = getPdfUrlsForCount(cappedCount);
  const zip = new JSZip();

  await Promise.all(
    pdfEntries.map(async ({ url, filename }) => {
      const blob = await fetchPdfAsBlob(url);

      zip.file(filename, blob);
    }),
  );

  const zipBlob = await zip.generateAsync({ type: 'blob' });

  return { blob: zipBlob, filename: 'statements.zip' };
};

export default createBatchDownloadBlob;
